import Ease from '../_utils/Ease';
import GetOffset from '../_utils/GetOffset';
import GetStyleTransformPrefix from '../_utils/GetStyleTransformPrefix';

export default class ParallaxImage {


	// Constructor
	constructor(element) {

		this.element = element;
		this.image = this.element.querySelector('img');
		if (this.image === null) {
			this.image = this.element.querySelector('video');
		}
		this.transform = GetStyleTransformPrefix();

		this.offset = 0;
		this.posCurrent = 0;
		this.posTarget = 0;
		this.posValue = 0;
		this.scrollMax = 0;
		this.scrollMin = 0;

	}


	// Public Methods
	animate() {
		this.posValue = Ease.lerp(this.posValue, this.posTarget, 0.5);
		if (Math.abs(this.posValue - this.posTarget) < Number.EPSILON) {
			this.posValue = this.posTarget;
		}
		if (this.posCurrent !== this.posValue) {
			const y = this.posValue * this.offset;
			this.image.style[this.transform] = 'translate3d(-50%, -' + y + 'px, 0)';
		}
		this.posCurrent = this.posValue;
	}
	resize() {

		const elementTop = GetOffset.top(this.element);
		const elementHeight = this.element.offsetHeight;
		const windowHeight = window.innerHeight;

		const imageHeight = this.image.offsetHeight;

		const elementAppear = elementTop - windowHeight;
		const elementDisappear = elementTop + elementHeight;

		this.offset = imageHeight - elementHeight;
		this.scrollMin = elementAppear;
		this.scrollMax = elementDisappear;

		this.scroll();
	}
	scroll() {
		const scrollY = window.pageYOffset;
		if (scrollY >= this.scrollMax) {
			this.posTarget = 1;
		} else if (scrollY >= this.scrollMin) {
			this.posTarget = (scrollY - this.scrollMin) / (this.scrollMax - this.scrollMin);
		} else {
			this.posTarget = 0;
		}
	}


}
